import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PostsService } from '../modules/core/services/posts.service';
@Component({
  standalone: false,
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit{

  constructor(
    private router:Router,
    public postsService: PostsService,
  )
  {}

  spremanjeStatus:string='';
  tokenStatus:string='';

  enterEmail ()
  {
    this.router.navigate(['']);
  }


ngOnInit(): void {
 document.body.style.overflow = 'hidden'; // zabrani scroll
  if (this.postsService.spremanjeStatus ==="ERROR" || this.postsService.spremanjeStatus ==="EXISTS"){
    this.spremanjeStatus = this.postsService.spremanjeStatus;
  }
  else if (this.postsService.spremanjeStatus ==="OK"){
    this.spremanjeStatus = this.postsService.spremanjeStatus;
  }
    else
    {
      this.tokenStatus = this.postsService.tokenStatus;
  }

}
}
